import { Row, Button, Rate } from 'antd';
import { t } from 'i18next';
import { useMutation } from 'react-query';
import { markFeedbackAsRead } from '@/common/services';
import { queryClient, showNotification } from '@/common/utils';
import { API_QUERIES } from '@/constants';
import styles from './styles.module.scss';
type Props = {
  sessionId: string;
  questions: API.SurveyQuestionDto[];
  answers: API.SurveyAnswer[];
  hideMarkAsReadBtn: boolean;
  onCancel: VoidFunction;
};

export function FeedbackReadonlyView(props: Props) {
  const { sessionId, questions, answers, hideMarkAsReadBtn, onCancel } = props;

  const markAsReadAction = useMutation(
    async (values: Object) => {
      await markFeedbackAsRead(sessionId);
    },
    {
      onSuccess() {
        queryClient.invalidateQueries([API_QUERIES.GET_FEEDBACK_CONTENT_BY_SESSION_ID, sessionId]);
        queryClient.invalidateQueries([API_QUERIES.GET_WAITING_FEEDBACK]);
        showNotification({ type: 'success', message: t('message.saveSuccess') });
        onCancel();
      },
    }
  );

  return (
    <div className={styles.userViewWrapper}>
      {questions.map((q) => {
        const result = answers.find((a) => a.surveyQuestionId === q.id);
        let value = result?.answer || '';

        if (q.questionType === 'MultipleChoice' || q.questionType === 'Dropdown') {
          const selectedOptions = q.questionOptions.filter((o) =>
            result?.surveyAnswerOptions.map((x) => x.surveyQuestionOptionId).includes(o.id)
          );
          value = selectedOptions
            .map((s) => s.optionText)
            .reduce((pre, acc) => {
              return (acc += `<p>${pre}</p>`);
            }, '');
        }

        if (q.questionType === 'ScaleRating') {
          return (
            <div className={styles.questionItem}>
              <div className={styles.questionLabel}>{q.questionText}</div>
              <div>
                <Rate className={styles.readonlyRate} value={parseInt(value)} allowClear={false} />
              </div>
            </div>
          );
        }

        return (
          <div className={styles.questionItem}>
            <div className={styles.questionLabel}>{q.questionText}</div>
            <div dangerouslySetInnerHTML={{ __html: value }} />
          </div>
        );
      })}
      {!hideMarkAsReadBtn && (
        <div className={styles.actionBar}>
          <Row justify="end" align="middle" gutter={12}>
            <div />
            <Button
              htmlType="button"
              loading={markAsReadAction.isLoading}
              onClick={markAsReadAction.mutate}
            >
              {t('myFeedbacks.markAsRead')}
            </Button>
          </Row>
        </div>
      )}
    </div>
  );
}
